<template>
    <div>
        <Navigation :alwaysTop="true" />

        <SmallerWithSearchAndButton
            :imageName="$t('UI.banners.smallerBannerImage')"
            :title="$t('solutions.name')"
            :description="$t('solutions.description')"
        />

        <section class="mm-section mm-section__banner-list">
            <div
                v-for="(item, index) in $t('solutions.items')"
                :key="item.id"
                class="mm-subsection mm-subsection--space-l"
                :style="`background-image: url(${item.imagePreview})`"
                :class="{
                    'mm-subsection--right': index%2 !== 0
                }">
                <div class="mm-subsection__mask"></div>

                <div v-if="index%2 == 0"
                    class="mm-section-content box--flex-horizontal box--flex-right">
                    <div class="mm-section__banner-list-text box box--space-right-l box--flex-vertical box--right">
                        <div class="headline headline--third">
                            {{item.name}}
                        </div>
                        <div class="text--basic-paragraph">
                            {{item.description}}
                        </div>
                    </div>
                    <div class="mm-section__banner-list-button box--flex box--flex-center">
                        <router-link :to="localeRoute(item.routeName)"
                            class="button button--xl normal--button button--small-text button--uppercase button--shadow">
                            {{item.buttonLabel}}
                        </router-link>
                    </div>
                </div>

                <div v-else class="mm-section-content box--flex-horizontal box--flex-left">
                    <div class="mm-section__banner-list-button box--flex box--flex-center">
                        <router-link :to="localeRoute(item.routeName)"
                            class="button button--xl normal--button button--small-text button--uppercase button--shadow">
                            {{item.buttonLabel}}
                        </router-link>
                    </div>
                    <div class="mm-section__banner-list-text box box--space-left-l box--flex-vertical box--left">
                        <div class="headline headline--third">
                            {{item.name}}
                        </div>
                        <div class="text--basic-paragraph">
                            {{item.description}}
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <app-footer />
    </div>
</template>

<script>

import { setPageTitle, setMeta, getPageTitle, getPageMetaDescription } from '@/utils/meta'
import Navigation from '../components/ui/Navigation/Navigation';
import SmallerWithSearchAndButton from '@/components/ui/Banner/SmallerWithSearchAndButton';

export default {
    components: {
        Navigation,
        SmallerWithSearchAndButton
    },
    created: function() {
        setPageTitle(getPageTitle(this.$route));
        setMeta("description", getPageMetaDescription(this.$route));
    }
}
</script>


<style lang="scss" scoped>
</style>
